import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, nextTick } from 'vue'
import plus from '@/utils/h5plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['ready'],
  setup(__props, { emit }) {



const statusbarElement = ref<HTMLElement>();

// 组件挂载完成
onMounted(() => {
  const el = statusbarElement.value;

  plus.getStatusBarHeight((height) => {
    el?.style.setProperty('padding-top', height + 'px');
  })

  nextTick(() => emit('ready', el));
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "statusbarElement",
    ref: statusbarElement,
    class: "app-statusbar"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})